export type TypePlanoContasTipo = {
    codigo?: number,
    tipo?: string,
    ativo?: boolean
}

export enum EnumPlanoContasTipoMovimentacao {
    Receita = 1,
    Despesa = 2
}

export enum EnumPlanoContasTipo {
    GRUPO = 1,
    ITEM = 2
}